/* Minimal navigation behavior. Works with Shopify's server-rendered menu. */
document.addEventListener('click',function(event){
 const mobile=event.target.closest('[data-btr-menu]');
 if(mobile){const panel=document.getElementById(mobile.getAttribute('aria-controls'));
   if(panel){let isOpen=mobile.getAttribute('aria-expanded')==='true'; mobile.setAttribute('aria-expanded',String(!isOpen)); panel.hidden=isOpen;}
   return;
 }
 const toggle=event.target.closest('[data-btr-dropdown]');
 if(toggle){const wrap=toggle.closest('.btr-nav-item'); const opening=toggle.getAttribute('aria-expanded')!=='true';
   document.querySelectorAll('[data-btr-dropdown]').forEach(b=>{b.setAttribute('aria-expanded','false');b.closest('.btr-nav-item')?.classList.remove('is-open')});
   toggle.setAttribute('aria-expanded',String(opening));wrap?.classList.toggle('is-open',opening);return;
 }
 if(!event.target.closest('.btr-nav-item')){document.querySelectorAll('[data-btr-dropdown]').forEach(b=>{b.setAttribute('aria-expanded','false');b.closest('.btr-nav-item')?.classList.remove('is-open')});}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('[data-btr-dropdown]').forEach(b=>{b.setAttribute('aria-expanded','false');b.closest('.btr-nav-item')?.classList.remove('is-open')});}});
